<template>
  <div class="page-report">
    <HeaderMegaposData/>
    <div class="page-header align-items-start min-vh-100 my-transacions">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto mt-4">
            <div class="row">
              <h2>Recipe Usage Report</h2>
            </div>
            <FormSearch
              :searchParameter="form"
              :onChangeSearchParameter="onChangeSearchParameter"
              :selectAllBranch="false"
              :hidePhysicalBranchFilter="false"
              :totalDaySelect="90"
              @reload-data="getList(page)"
              @export="exportFile"
            ></FormSearch>
            <div
              class="row mt-4"
              style="min-height: 1120px"
              v-if="isLoadDone"
              v-show="isLoadDoneDataTable"
            >
              <div class="col-12">
                <div>
                  <div class="px-0 pb-2">
                    <div class="d-flex justify-content-end align-items-center mb-3">
                      <label class="global-search mb-0">Search:
                        <input
                          type="search"
                          v-model="searchKeyword"
                          @input="onKeywordSearch"
                        />
                      </label>
                    </div>
                    <div class="p-0 custom-table">
                      <table
                        class="table align-items-center mb-0 dataTable"
                        ref="dataTable"
                      >
                        <thead>
                          <tr>
                            <th class="text-center font-weight-bolder">
                              <div class="pt-4">Row No</div>
                            </th>
                            <template
                              v-for="(item, index) in headersData"
                              :key="index"
                            >
                              <th
                                class="text-center font-weight-bolder position-relative"
                              >
                                <div
                                  class="pt-4"
                                  style="position: unset"
                                  :class="[
                                    !!item.hasSortBy
                                      ? 'wrapper-sortby pointer'
                                      : '',
                                    ESortDirectionSelect.idx == index + 1
                                      ? ESortDirectionSelect.direction ===
                                        ESortDirection.Desc
                                        ? 'sort-desc'
                                        : 'sort-asc'
                                      : '',
                                  ]"
                                  @click="
                                    handleChangeSortColumn(
                                      index + 1,
                                      item.field
                                    )
                                  "
                                >
                                  {{ item.label }}
                                </div>
                              </th>
                            </template>
                          </tr>
                        </thead>
                        <tbody v-if="items && items.length">
                          <tr v-for="(value, key) in items" :key="key">
                            <td class="text-right text-xss w-5">
                              {{ rowNo(key) }}
                            </td>
                            <td class="text-left text-xss">
                              {{ value?.branch_name }}
                            </td>
                            <td class="text-left text-xss">
                              {{ value?.recipe_item_no }}
                            </td>
                            <td class="text-left text-xss">
                              {{ value?.recipe_item_name }}
                            </td>
                            <td class="text-right text-xss">
                              {{ formatUnitCost(value?.unit_cost) }}
                            </td>
                            <td class="text-right text-xss">
                              {{ formatPrice(value?.total_cost) }}
                            </td>
                            <td class="text-right text-xss">
                              {{ formatQty(value?.total_qty) }}
                            </td>
                            <td class="text-left text-xss">
                              {{ value?.uom }}
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else class="no-data">
                          <tr>
                            <td :colspan="headersData.length + 1" class="text-left">No matching records found</td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr class="total-row">
                            <td class="text-right text-xss">TOTAL</td>
                            <td class="text-left text-xss"></td>
                            <td class="text-left text-xss"></td>
                            <td class="text-left text-xss"></td>
                            <!-- Unit Cost is deliberately blank: a sum of per-material
                                 unit costs would be meaningless. -->
                            <td class="text-right text-xss"></td>
                            <td class="text-right text-xss">{{ formatPrice(totalCost) }}</td>
                            <!-- Total Quantity is deliberately blank: the rows mix
                                 gram, ml and pcs, so one sum would be meaningless. -->
                            <td class="text-right text-xss"></td>
                            <td class="text-left text-xss"></td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between align-items-center mb-3 px-3 pt-3">
                    <div class="rows-per-page">
                      <span class="rows-per-page__label">Rows per page</span>
                      <div class="rows-per-page__control">
                        <select v-model="limit" @change="setLimitPerPage" class="rows-per-page__select">
                          <option :value="20">20</option>
                          <option :value="50">50</option>
                          <option :value="100">100</option>
                        </select>
                      </div>
                    </div>
                    <pagination
                      v-if="pagination.last_page > 1"
                      :pagination="pagination"
                      :current_page="pagination.current_page"
                      :last_page="pagination.last_page"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
    </div>
    <form
      :action="`${actionDownload}/merchant/analytics/recipe-usage/export`"
      method="POST"
    >
      <input type="hidden" name="merchantId" :value="merchantIdExport" />
      <input type="hidden" name="merchant_code" :value="merchantCode" />
      <input type="hidden" name="token" :value="token" />
      <input type="hidden" name="physical_branch_id" :value="form.physical_branch_id" />
      <input type="hidden" name="from_date" :value="from_date_export" />
      <input type="hidden" name="to_date" :value="to_date_export" />
      <input type="hidden" name="action_export" :value="action_export" />
      <input type="hidden" name="action" value="export" />
      <input id="downloadForm" type="submit" class="d-none" />
    </form>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import "bootstrap/js/dist/modal";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";
import AnalyticsService from "../../services/analytics.service";
import { startOfMonth } from "date-fns";
import $ from "jquery";
import TokenService from "../../services/token.service";
import FormSearch from "./components/FormSearch.vue";
import Pagination from '@/components/Pagination.vue'
import HeaderMegaposData from "./components/HeaderMegaposData.vue";

export default {
  name: "recipe-usage-report",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    FormSearch,
    Pagination,
    HeaderMegaposData,
  },
  data() {
    return {
      isLoadDone: false,
      isLoadDoneDataTable: false,
      token: TokenService.getLocalAccessToken(),
      actionDownload: process.env.VUE_APP_BASE_URL,
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCode: localStorage.getItem("MERCHANT_CODE", ""),
      message: "",
      snackbar: null,
      loaderActive: false,
      items: null,
      form: {
        physical_branch_id: -1,
        branch_id: -1,
        from_date: moment(startOfMonth(new Date())),
        to_date: new Date(),
      },
      ESortDirectionSelect: {
        idx: null,
        field: "",
        direction: null,
      },
      ESortDirection: {
        Asc: "asc",
        Desc: "desc",
      },
      action_export: "csv",
      from_date_export: "",
      to_date_export: "",
      pagination: {},
      page: 1,
      limit: 20,
      totalCost: 0,
      totalRecords: 0,
      searchTimer: null,
      searchKeyword: "",
    };
  },
  computed: {
    headersData() {
      return [
        {
          label: "Branch",
          field: "branch_name",
          hasSortBy: true,
        },
        {
          label: "Recipe No",
          field: "recipe_item_no",
          hasSortBy: true,
        },
        {
          label: "Recipe Name",
          field: "recipe_item_name",
          hasSortBy: true,
        },
        {
          label: "Unit Cost",
          field: "unit_cost",
          hasSortBy: true,
        },
        {
          label: "Total Cost",
          field: "total_cost",
          hasSortBy: true,
        },
        {
          label: "Total Quantity",
          field: "total_qty",
          hasSortBy: true,
        },
        {
          label: "UOM",
          field: "uom",
          hasSortBy: true,
        },
      ];
    },
  },
  mounted() {
    this.getList(this.page);
  },
  methods: {
    // Row No keeps counting across pages — page 2 starts at 21, not back at 1.
    rowNo(indexOnPage) {
      const page = this.pagination.current_page || 1;
      return (page - 1) * this.limit + indexOnPage + 1;
    },

    formatPrice(price) {
      return (
        "$ " +
        Number(price ?? 0).toLocaleString("en-US", { minimumFractionDigits: 2 })
      );
    },

    // Unit cost carries 4 decimals rather than the 2 used for Total Cost: many of
    // the raw materials are priced below a cent (RS026 = $0.0340), and rounding
    // those to $0.03 would hide the real figure.
    formatUnitCost(price) {
      return (
        "$ " +
        Number(price ?? 0).toLocaleString("en-US", {
          minimumFractionDigits: 4,
          maximumFractionDigits: 4,
        })
      );
    },

    // Usage runs into the tens of thousands of grams, so it needs the thousand
    // separators; the decimals stay optional because most recipes are whole units.
    formatQty(qty) {
      return Number(qty ?? 0).toLocaleString("en-US");
    },

    exportFile(type = "csv") {
      this.action_export = type;
      this.from_date_export = this.dateFormat(this.form.from_date);
      this.to_date_export = this.dateFormat(this.form.to_date);
      setTimeout(() => {
        $("#downloadForm").click();
      }, 150);
    },

    dateFormat(date) {
      if (date == null) {
        return null;
      } else {
        return moment(date).format("YYYY-MM-DD");
      }
    },

    onChangeSearchParameter(value, fieldName) {
      this.form[fieldName] = value !== null ? value : "-1";
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    onKeywordSearch() {
      // Debounce so we query the server once the user pauses typing; reset to
      // page 1 because the filtered result set (and its total) changes.
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.page = 1;
        this.getList(1);
      }, 500);
    },

    handleChangeSortColumn(idx, field) {
      if (
        this.ESortDirectionSelect.idx &&
        this.ESortDirectionSelect.idx == idx
      ) {
        this.ESortDirectionSelect.direction =
          this.ESortDirectionSelect.direction === this.ESortDirection.Asc
            ? this.ESortDirection.Desc
            : this.ESortDirection.Asc;
      } else {
        this.ESortDirectionSelect = {
          idx: idx,
          field: field,
          direction: this.ESortDirection.Asc,
        };
      }

      // Sort on the server so it orders the whole result set, not just this page.
      this.getList(this.page);
    },

    getList(page) {
      this.showLoader();
      var dataForm = {
        physical_branch_id: this.form.physical_branch_id,
        from_date: this.dateFormat(this.form.from_date),
        to_date: this.dateFormat(this.form.to_date),
        page: page,
        keyword: this.searchKeyword,
        sort_field: this.ESortDirectionSelect.field,
        sort_type: this.ESortDirectionSelect.direction,
        limit: this.limit,
      };

      AnalyticsService.recipeUsageReport(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const data = response.data.data
            this.items = data.items
            this.pagination = data
            this.page = this.pagination.current_page
            this.totalRecords = this.pagination.total
            this.totalCost = data.total_cost ?? 0

            if (
              this.pagination.current_page > this.pagination.last_page &&
              this.pagination.total > 0
            ) {
              this.page = 1
              this.getList(this.page)
              return
            }

            this.$router.push({
              query: Object.assign({}, this.$route.query, { page: this.page }),
            })

            this.isLoadDone = true;
            this.isLoadDoneDataTable = true;
            this.hideLoader();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
            this.hideLoader();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    setLimitPerPage() {
      // Reset to page 1 when changing limit
      this.page = 1;
      this.getList(1);
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },
  },
};
</script>
<style scoped>
table thead th:not(:first-child) {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

table thead th > span {
  position: relative;
}

input[type="search"] {
  border: none;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
}

input[type="search"]::placeholder {
  color: #bbb;
  text-align: left;
  font-weight: normal;
}

input[type="search"]:focus {
  border-color: #72959d;
  outline: none;
  border: none;
  border-bottom: 2px solid #72959d;
}

.date-time-dashboad .dp__input_wrap {
  min-width: 200px !important;
  width: 250px;
}

tbody:not(.no-data) > tr:nth-child(2n + 1) {
  background: #f0f2f5;
}

tbody:not(.no-data) > tr:hover {
  background: #ebecee;
}

.custom-table :not(caption) > * > * {
  border-right-width: 1px !important;
}

.custom-table :not(caption) > * > *:first-child {
  border-left-width: 1px !important;
}

/* Empty-state ("No matching records found") cell: keep the same left/right grid
   borders as the data rows (the width-only rules above don't render on this
   single colspan cell). */
.custom-table tbody.no-data > tr > td {
  border-left: 1px solid #dee2e6 !important;
  border-right: 1px solid #dee2e6 !important;
}

tfoot tr.total-row {
  font-weight: bold;
  color: #222;
  background: #e9edf2;
}

tfoot tr.total-row td {
  border-top: 2px solid #dee2e6;
}

/* Horizontal scroll lives in the table region; the page scrolls vertically. */
.custom-table {
  overflow-x: auto;
}

/* Bootstrap only draws a *bottom* border on table cells, so without this the
   first header row has no line above it and the header looks cut off. */
.custom-table thead tr:first-child th {
  border-top: 1px solid #dee2e6 !important;
}

/* Global "Search:" box */
.global-search {
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.global-search input {
  padding: 6px 12px;
  border: 1px solid #d2d6da;
  font-size: 13px;
  font-weight: normal;
  color: #495057;
  background: #fff;
  min-width: 220px;
}

.global-search input:focus {
  outline: none;
  border: 1px solid #72959d;
  box-shadow: 0 0 0 2px rgba(114, 149, 157, 0.15);
}
</style>
